var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8172 41.941C46.8172 43.3031 46.2385 44.5516 45.3126 45.4597C44.3867 46.3678 43.1135 46.9353 41.7247 46.9353H34.0281V50H41.7826C44.0395 49.9432 46.0649 49.0352 47.5695 47.5596C49.0741 46.084 49.9421 44.0976 49.9421 41.8842V33.8252H46.8172V41.941Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9421 8.00227C49.9421 5.78887 49.0162 3.8025 47.5695 2.3269C46.0649 0.851305 44.0395 0 41.7826 0H34.0281V3.0647H41.7826C43.1714 3.0647 44.4445 3.63223 45.3705 4.54029C46.2964 5.44835 46.8751 6.69693 46.8751 8.05902V16.1748H50V8.00227H49.9421Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62954 45.403C3.70363 44.4949 3.12494 43.2463 3.12494 41.8842V33.8252H0V41.941C0 44.1544 0.925908 46.1407 2.37264 47.6163C3.93511 49.0352 5.96054 49.9432 8.21744 49.9432H15.9719V46.8785H8.21744C6.82857 46.8785 5.55545 46.311 4.62954 45.403Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.18342 8.00227C3.18342 6.64018 3.76212 5.3916 4.68802 4.48354C5.61393 3.57548 6.88706 3.00795 8.27592 3.00795H16.0304V0H8.21805C5.96115 0 3.93572 0.908059 2.43112 2.3269C0.92652 3.8025 0.0584811 5.78888 0.0584811 8.00227V16.118H3.18342V8.00227Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16L34 34M34 16.75L16 34",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoIcon);
export default __webpack_public_path__ + "static/media/photo_icon.aea309de66b3b31455253b5c656e766c.svg";
export { ForwardRef as ReactComponent };